import { Platform } from "react-native";
import styled from "styled-components/native";
import { paddingProps, PaddingProps } from "@sloth-system/props";

export { Float };

function fullWidthProps(props) {
  if (props.fullWidth) {
    return "width: 100%;";
  }
  return;
}

let platformSpecificStyles =
  Platform.OS === "web"
    ? `
  position: fixed;
`
    : `
    position: absolute;
    
    `;

let Float = styled.View<PaddingProps & { fullWidth?: boolean }>`
  ${platformSpecificStyles}
  bottom: 0;
  left: 0;
  ${paddingProps}
  ${fullWidthProps}
`;
